export default "__VITE_ASSET__96986317__"